export default "__VITE_ASSET__zVKoVbFx__"